/**
 *@author yudeping
 *富文本弹窗
 */

import template from './quill-alert.html';
import Component from '../../../../app/lib/component'
let css = `
    .editor{
        border: solid 1px #ccc;
    }
`;
let WangEditor;
try{
    WangEditor = require('wangeditor');
} catch (err) {
    console.log(err)
}
let config = {
    template: template.replace(/(\")/g, '\''),
    data: {
        css: css.replace(/(\n)/g, ''),
        value: '',
    },
    afterRender() {
        this.data.style = $("<style></style>").text(this.data.css).appendTo($("head"));
        let toolbarWrap = this.el.find('.content .toolbar');
        let editWrap = this.el.find('.content .editor');
        this.data.wangEditor = new WangEditor(toolbarWrap[0],editWrap[0]);
        this.data.wangEditor.customConfig.menus = [];
        this.data.wangEditor.create();
        this.data.value = '<p>' + this.data.value + '</p>';
        this.data.wangEditor.txt.html(this.data.value);
        //设置只读
        this.data.wangEditor.$textElem.attr('contenteditable', false);
    },
    beforeDestory() {
        this.data.wangEditor = null;
    }
};
let QuillAlert = Component.extend(config);
export default QuillAlert

const QuillAlertDialog= {
    el:null,
    show:function (config) {
        let component = new QuillAlert(config);
        this.el = $('<div class="QuillAlert-dialog">').appendTo(document.body);
        component.render(this.el);
        this.el.erdsDialog({
            title: config.data.title,
            width: 1200,
            height: 650,
            modal: true,
            close: function() {
                $(this).erdsDialog('destroy');
                component.destroySelf();
            }
        });
    },
    hide:function () {
        this.el.erdsDialog('close');
    }
};
export {QuillAlertDialog}



// WEBPACK FOOTER //
// app/components/form/quill-alert/quill-alert.js